import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import InboxMessageProp from '../../../../../propTypes/inboxMessageProp';
import translate from '../../../../../../../commonComponents/translate';
import { colors } from '../../../../../../../services/utilityFunctions';
import InboxContainer from '../InboxContainer';
import ProfileIcon from '../icons/ProfileIcon';

function ProfilingMessage({ t, message }) {
  const { profileBlock, createdAt } = message;

  const handleClick = useCallback(() => {
    window.location.href = `/profile/${profileBlock}`;
  }, [profileBlock]);

  return (
    <InboxContainer
      style={{
        '--news-item-bg': colors('inverse'),
        '--news-item-title': colors('dynamic'),
        '--news-item-text': '#6F6C80',
      }}
      image={() => <ProfileIcon block={profileBlock} />}
      title={t('inbox_profiling_title')}
      createdAt={createdAt}
      link={t('inbox_fillNow')}
      onClick={handleClick}
    >
      {t(
        'inbox_profiling_description',
        t(`inbox_profiling_description_${profileBlock}`),
      )}
    </InboxContainer>
  );
}

ProfilingMessage.propTypes = {
  t: PropTypes.func.isRequired,
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
};

export default translate(ProfilingMessage);
